import React, { useEffect, useState } from 'react';
import { tryToDownloadBaseWordlistFile, getCurrentWordlistObj, useSwdContext } from '../../libs/autofillLib';
import { Modal } from 'react-bootstrap';
import { MdOutlineOpenInNew } from 'react-icons/md';
import LoaderButton from '../reusable/LoaderButton';
import { GrDocumentTxt } from 'react-icons/gr';



export default function ViewWordlistModal({ show, onHide }) {

  const { swdVersion } = useSwdContext();
  const [wordlist, setWordlist] = useState(null);

  const [isDownloadingBaseWordlist, setIsDownloadingBaseWordlist] = useState(false);

  useEffect(() => {
    setWordlist(getCurrentWordlistObj());
  }, [swdVersion]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header className='fw-bold purple-1-bkgd' closeButton>
        {wordlist?.name || '(untitled wordlist)'}
      </Modal.Header>

      <Modal.Body>
        {wordlist?.name && <div className='d-flex gap-3'>
          <div className='fw-bold'>Name</div>
          <div>{wordlist.name}</div>
        </div>}

        {wordlist?.author && <div className='d-flex gap-3 small'>
          <div className='fw-bold'>Author</div>
          <div>{wordlist.author}</div>
        </div>}

        {wordlist?.link && <div className='d-flex gap-3 small'>
          <div className='fw-bold'>Website</div>
          <div>
            {/^(https?:\/\/)?(www\.)?[a-z0-9-]+(\.[a-z]{2,})(\/\S*)?$/i.test(wordlist.link) ? (
              <a href={wordlist.link} target="_blank" rel='noopener noreferrer'>{wordlist.link} <MdOutlineOpenInNew /></a>
            ) : (
              <span>wordlist.link</span>
            )}
          </div>
        </div>}

        {wordlist?.description && <div className='d-flex gap-3'>
          <div className='fw-bold'>Description</div>
          <div>{wordlist.description}</div>
        </div>}

        {wordlist?.baseWordlist && <div className='d-flex gap-3 mt-2 align-items-center'>
          <div className='fw-bold'>File</div>
          <div className='d-flex gap-2 align-items-center text-success my-3'>
            <div className='d-flex align-items-center gap-1 px-1 py-2 border border-success rounded-1'>
              <GrDocumentTxt />
              <span className='text-xs'>{wordlist.baseWordlist.filename}</span>
            </div>
            <LoaderButton
              variant='link'
              size='sm'
              isLoading={isDownloadingBaseWordlist}
              onClick={async () => {
                setIsDownloadingBaseWordlist(true);
                await tryToDownloadBaseWordlistFile(wordlist.baseWordlist.baseWordlistId, wordlist.baseWordlist.filename);
                setIsDownloadingBaseWordlist(false);
              }}
            >Download</LoaderButton>
          </div>
        </div>}
      </Modal.Body>
    </Modal>
  );
}